import { Improvement } from '../../../improvement'
import { TargetMode } from '../../../../targets'

export const lookbackWindows = [
    Improvement.LookbackWindow.SEVEN_DAYS,
    Improvement.LookbackWindow.FOURTEEN_DAYS,
    Improvement.LookbackWindow.THIRTY_DAYS,
    Improvement.LookbackWindow.SIXTY_DAYS,
    Improvement.LookbackWindow.NINETY_DAYS,
] as const

interface BodyBase {
    keywordId: number
    keyword: string
    matchType: string
    campaignGroupId: string
    campaignId: number
    campaignName: string
    adGroupId: number
    adGroupName: string
    metrics: Metrics
    newBid?: number
    window: LookbackWindowValue
}

export type Metrics = {
    conversions: number
    spend: number
    clicks: number
    impressions: number
    impressionSharePercent: number
    topImpressionRatePercent: number
    absoluteTopImpressionRatePercent: number
    firstPageBid: number
    qualityScore: number
    campaignGroupTargetCpa: number
}

type LookbackWindowValue = (typeof lookbackWindows)[number]

export interface PauseKeywordBody extends BodyBase {
    campaignGroupTargetMode: TargetMode
}

export interface AdjustKeywordBidsBody extends BodyBase {
    newBid: number
    currentBid: number
    bidChange: number
    campaignGroupTargetMode: TargetMode
    scatterPointChartItems: ScatterPointChartItem[]
}

export interface IncreaseKeywordBidsBody extends BodyBase {
    newBid: number
    currentBid: number
    bidChange: number
    impressionSeries?: AreaChartSeries[]
    impressionShareSeries?: AreaChartSeries[]
}

export type Body = PauseKeywordBody | AdjustKeywordBidsBody | IncreaseKeywordBidsBody

export interface ExtraDetails {
    newBid: number
}

export interface ScatterPointChartItem {
    x: number
    y: number
    label: string
    highlighted?: boolean
}

export interface AreaChartSeries {
    name: string
    items: { x: number; y: number }[]
}
